import { useBlocksConfig } from "@pathwright/blocks-engine"
import { MuxEmbed } from "@pathwright/legacy-media-manager"
import PropTypes from "prop-types"
import AttachmentsAdd from "../AttachmentsAdd/AttachmentsAdd"
import { AttachmentsListWrapper } from "../ui"
import AttachmentsListItem from "./AttachmentsListItem"

export const AttachmentsList = (props) => {
  const {
    attachments,
    onRemoveAttachment,
    onAddAttachment,
    renderAddAttachment,
    onUpdateAttachmentName,
    mode,
    blockID,
    isDisabled
  } = props

  const { theme, isLocal } = useBlocksConfig()

  const mapped = attachments.map((attachment, i) => {
    if (attachment.name === "empty") return null

    const attachmentProps = {
      mode: isDisabled ? "view" : mode,
      domID: attachment.id || `block-${blockID}-attachment-${i}`,
      attachment,
      onRemoveAttachment: (attachment) => onRemoveAttachment(attachment, i),
      onUpdateAttachmentName,
      theme
    }

    const key = `attachment-${blockID}-${i}-${attachment.mediaID}`

    return attachment.muxVideoID ? (
      <MuxEmbed key={key} id={attachment.muxVideoID} isLocal={isLocal}>
        <AttachmentsListItem {...attachmentProps} />
      </MuxEmbed>
    ) : (
      <AttachmentsListItem {...attachmentProps} key={key} />
    )
  })

  return (
    <AttachmentsListWrapper className="AttachmentsList">
      {mapped}
      {mode === "edit" ? (
        !!renderAddAttachment ? (
          renderAddAttachment()
        ) : (
          <AttachmentsAdd onAddAttachment={onAddAttachment} />
        )
      ) : null}
    </AttachmentsListWrapper>
  )
}

AttachmentsList.propTypes = {
  mode: PropTypes.oneOf(["edit", "view"]),
  attachments: PropTypes.array.isRequired,
  onRemoveAttachment: PropTypes.func,
  onAddAttachment: PropTypes.func,
  renderAddAttachment: PropTypes.func,
  onUpdateAttachmentName: PropTypes.func,
  // Allows us to have unique keys for React
  blockID: PropTypes.string
}

AttachmentsList.defaultProps = {
  mode: "view"
}

export default AttachmentsList
